import { PieChart } from "@mui/x-charts/PieChart";
import { Box, useMediaQuery } from "@mui/material";
import React from "react";

interface AirlineData {
  airline_code: string;
  airline_name: string;
  booking_count: number;
  passenger_count: number;
  total_revenue: number;
  market_share: number;
}

interface TopAirlinesBarGraphProps {
  data: AirlineData[];
}

const TopAirlinesBarGraph = ({ data }: TopAirlinesBarGraphProps) => {
  const [radius, setRadius] = React.useState(50);
  const [itemNb, setItemNb] = React.useState(5);
  const [skipAnimation, setSkipAnimation] = React.useState(false);

  // Transform API data for PieChart
  const chartData = data.map((airline, index) => ({
    label: airline.airline_name,
    value: airline.market_share,
    color: ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#A020F0"][index % 5], // rotating colors
  }));

  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <div className="h-100 border-0 shadow-sm card top-airline-card">
      <div className=" card-header dashboard-card-header">
        <h6 className="mb-0 fw-semibold">Top Airlines</h6>
      </div>
      <div className="card-body">
        <Box
          sx={{
            width: "100%",
            "& .MuiChartsLegend-mark": {
              width: 20,
              height: 20,
              borderRadius: 2,
            },
          }}
        >
          <PieChart
            height={276}
            width={isMobile ? 310 : 334} // 👈 mobile vs desktop
            margin={{ right: isMobile ? 120 : 140 }}
            series={[
              {
                data: chartData.slice(0, itemNb), // use API-transformed data
                innerRadius: radius,
                outerRadius: 100,
                arcLabel: (params: any) => `${params.value}%`,
                arcLabelMinAngle: 20,
              },
            ]}
            skipAnimation={skipAnimation}
            slotProps={{
              legend: {
                direction: "column",
                position: {
                  vertical: "middle",
                  horizontal: "right",
                },
                itemGap: 8,
                markGap: 8,
              },
            }}
          />
        </Box>
      </div>
    </div>
  );
};

export default TopAirlinesBarGraph;
